import { Page } from '@app/components/page/Page';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { useIntl } from 'react-intl';
import { YoutubeBroadcastsList } from './YoutubeBroadcastsList';
import { YoutubeNativeStationNavigator } from './YoutubeNativeStationNavigator';
import { youtubeBroadcastsListMessages } from './youtube-broadcasts-list.messages';

/** Page shell for browsing YouTube broadcasts by date for a YouTube Native station. */
export function YoutubeBroadcastsListPage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  const title = $t(youtubeBroadcastsListMessages.pageTitle);

  return (
    <Page htmlTitle={`${title} | ${station.name}`}>
      <Page.Header
        icon={<YouTubeIcon />}
        title={[
          title,
          <YoutubeNativeStationNavigator
            key={station.id}
            activeId={station.id}
            basePath="youtube-broadcasts"
          />,
        ]}
      />
      <YoutubeBroadcastsList key={station.id} station={station} />
    </Page>
  );
}
